// extracted by mini-css-extract-plugin
module.exports = {"btn":"AdminPages_btn__CYGjg","btnAlt":"AdminPages_btnAlt__24eXp","breadcrumbs":"AdminPages_breadcrumbs__1PYix"};